const gradeArray = [
  "10 (E.G. O-level First Year)",
  "11 (E.G. O-level Second Year)",
  "12 (E.G. A-level First Year)",
  "13 (E.G. A-level Second Year)",
];

export default gradeArray;
